module.exports = __webpack_public_path__ + "b9b7d0bc1d35b84b9e66f3f49f8bef3f.svg";